import { types } from 'mobx-state-tree';
import { ApiStore } from './ApiStore';
import LoginStore from './LoginStore';
import DashBoardStore from './DashBoardStore';
import FeedBotStore from './FeedBotStore';

export const RootStore = types.model('RootStore', {
  apiStore: types.optional(ApiStore, {}),
  loginStore: types.optional(LoginStore, {}),
  dashBoardStore: types.optional(DashBoardStore, {}),
  feedBotStore: types.optional(FeedBotStore, {}),
});



// WEBPACK FOOTER //
// ./src/stores/RootStore.js